import { lazy } from 'react';
import { Route } from 'react-router';

const PreQuestionnaires = lazy(() => import('@/pages/funnel/questionnaires/PreQuestionnaire'));

export const PreQuestionnaireRoutes = () => (
  <Route path="/products">
    <Route path=":slug/pre_questionnaire" element={<PreQuestionnaires />} />
  </Route>
);
